import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import * as notAuthorizedOnlyGuard from '@auth/guards/not-authorized-only.guard';
import { ForgotPasswordComponent } from '@auth/pages/forgot-password/forgot-password.component';
import { LoginComponent } from '@auth/pages/login/login.component';
import { RegistrationComponent } from '@auth/pages/registration/registration.component';
import { RestorePasswordComponent } from '@auth/pages/restore-password/restore-password.component';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { registrationMatcher } from '@core-matchers/registration.matcher';
import { registrationGuard } from './guards/registration.guard';
import { agentSelectionGuard } from './guards/agent-selection.guard';

const routes: Routes = [
    {
        path: RpcRoute.ForgotPassword,
        component: ForgotPasswordComponent,
        data: { title: 'Forgot Password', applyDefaultLayout: true, hideUnauthorizedToolbar: true },
        canActivate: [notAuthorizedOnlyGuard.canActivate]
    },
    {
        path: RpcRoute.Login,
        component: LoginComponent,
        data: { title: 'Login', hasThemeSidebar: true, hideToolbarLoginRedirect: true, applyDefaultLayout: true, hideUnauthorizedToolbar: true },
        canActivate: [notAuthorizedOnlyGuard.canActivate]
    },
    {
        path: RpcRoute.RestorePassword,
        component: RestorePasswordComponent,
        data: { title: 'Restore Password', applyDefaultLayout: true, hideUnauthorizedToolbar: true },
        canActivate: [notAuthorizedOnlyGuard.canActivate]
    },
    {
        matcher: registrationMatcher,
        component: RegistrationComponent,
        data: { title: 'Registration', applyDefaultLayout: true, hideUnauthorizedToolbar: true },
        canActivate: [registrationGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }